<script setup lang="ts">
import Chart from 'chart.js/auto';
import {Model} from "@/app/Model";
import {RouterLink} from "vue-router";
import {onMounted, ref} from 'vue';
import * as bootstrap from 'bootstrap';
import type {KeyValoreStrNum, KeyValoreStrNumArr, KeyValoreStrNumBool} from "@/app/data/DataTypes";
import PaginazionePercorso from "@/components/atomics/PaginazionePercorsoResponsabilita.vue";
import PaginazionePercorsoJump from "@/components/atomics/PaginazionePercorsoResponsabilitaJump.vue";
import {PdfGenerator} from "@/app/PdfGenerator";
import {CommsResponsabilita, type IEsito} from "@/app/CommsResponsabilita";
import MinMaxSlider from "@/components/atomics/MinMaxSliderPercorsoRes.vue";

declare let frontendConfig: any;
declare let gtagO: Function;

//const initialTimeout: number = 1000;
let model: Model = Model.getReactiveInstance();
let chartTipologiaDanno: Chart | null = null;
let chartTipologiaDannoPatrimoniale: Chart | null = null;
let chartTipologiaDannoNonPatrimoniale: Chart | null = null;
let chartDomandaAccolta: Chart | null = null;
let chartRisarcimento: Chart | null = null;

const CHART_COLORS = {
  gfl1: 'rgb(33, 150, 243)',
  gfl2: 'rgb(22, 91, 170)',
  gfl3: 'rgb(79, 195, 247)',
  gfl4: 'rgb(19, 51, 113)',
  gfl5: 'rgb(227, 242, 253)',
  gfl6: 'rgb(41, 98, 255)',
  gfl7: 'rgb(161, 85, 185)',
  gfl8: 'rgb(22, 191, 214)'
};

onMounted(() => {
  checkStart();
});
function checkStart(): void {
  if (!Model.res_setupped) {
    setTimeout(() => checkStart(), 100)
  } else if (!CommsResponsabilita.listAllDone) {
    CommsResponsabilita.getInstance().listAll(() => {
      checkStart();
    });
  } else {
    initComponents();
  }
}

//COMPONENTS
function initComponents(): void {

  //LO DEVE FARE?
  //chiama i dati attuali
  callQuery();
  //ALTRIMENTI
  //updateComponents();
}
window.addEventListener(
    "listAllRefresh",
    (event) => {
      updateComponents();
      //if (choices && model.res_flow_percorso.capo_imputazione_legge != "") choices.setChoiceByValue(model.res_flow_percorso.capo_imputazione_legge);
    }
);
window.addEventListener(
    "resetRefresh",
    (event) => {
      changePercorsoAt('all');
    }
);
function updateComponents(): void {
  //TOOLTIPS
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
  updateCharts();
  updatePaginazione();
}
function updateCharts(): void {
  updateChartsTipologiaDanno();
  updateChartsTipologiaDannoPatrimoniale();
  updateChartsTipologiaDannoNonPatrimoniale();
  updateChartsDomandaAccolta();
  updateChartsRisarcimento();
}

//CHARTS
function updateChartsTipologiaDanno(): void {
  if (Chart.getChart("canvas_tipologia_danno")) {
    Chart.getChart("canvas_tipologia_danno")?.destroy();
  }
  if (model.res_get_percorso.tipologia_danno.length > 0) {
    const configTipologiaDanno = {
      type: 'doughnut',
      data: {
        labels: [],
        datasets: [{
          label: 'Tipologia danno',
          data: [],
          backgroundColor: Object.values(CHART_COLORS),
          hoverOffset: 4
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'right',
            onClick: null
          }
        }
      }
    };

    model.res_get_percorso.tipologia_danno.forEach((x: KeyValoreStrNum) => {
      //@ts-ignore
      configTipologiaDanno.data.labels.push(x.tipologia_danno + " (" + x.percentuale + "%)");

      //@ts-ignore
      configTipologiaDanno.data.datasets[0].data.push(x.percentuale);
    });

    let canvasTipologiaDanno: HTMLElement | null = document.getElementById('canvas_tipologia_danno');

    //@ts-ignore
    chartTipologiaDanno = new Chart(canvasTipologiaDanno, configTipologiaDanno);
  }
}
function updateChartsTipologiaDannoPatrimoniale(): void {
  if (Chart.getChart("canvas_tipologia_danno_patrimoniale")) {
    Chart.getChart("canvas_tipologia_danno_patrimoniale")?.destroy();
  }

  if (model.res_get_percorso.tipologia_danno_patrimoniale && model.res_get_percorso.tipologia_danno_patrimoniale.length > 0) {
    const configTipologiaDannoPatrimoniale = {
      type: "doughnut",
      data: {
        labels: [],
        datasets: [{
          label: 'Danno patrimoniale',
          data: [],
          backgroundColor: Object.values(CHART_COLORS),
          hoverOffset: 4
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'right',
            onClick: null
          }
        }
      }
    }

    model.res_get_percorso.tipologia_danno_patrimoniale.forEach((x: KeyValoreStrNumArr) => {
      //@ts-ignore
      configTipologiaDannoPatrimoniale.data.labels.push(x.tipologia_danno_patrimoniale + " (" + x.percentuale + "%)");

      //@ts-ignore
      configTipologiaDannoPatrimoniale.data.datasets[0].data.push(x.percentuale);
    });

    let canvasTipologiaDannoPatrimoniale: HTMLElement | null = document.getElementById('canvas_tipologia_danno_patrimoniale');

    //@ts-ignore
    chartTipologiaDannoPatrimoniale = new Chart(canvasTipologiaDannoPatrimoniale, configTipologiaDannoPatrimoniale);

  }
}
function updateChartsTipologiaDannoNonPatrimoniale(): void {
  if (Chart.getChart("canvas_tipologia_danno_non_patrimoniale")) {
    Chart.getChart("canvas_tipologia_danno_non_patrimoniale")?.destroy();
  }

  if (model.res_get_percorso.tipologia_danno_non_patrimoniale.length > 0) {
    const configTipologiaDannoNonPatrimoniale = {
      type: 'doughnut',
      data: {
        labels: [],
        datasets: [{
          label: 'Danno non patrimoniale',
          data: [],
          backgroundColor: Object.values(CHART_COLORS),
          hoverOffset: 4
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'right',
            onClick: null
          }
        }
      }
    };

    model.res_get_percorso.tipologia_danno_non_patrimoniale.forEach((x: KeyValoreStrNum) => {
      //@ts-ignore
      configTipologiaDannoNonPatrimoniale.data.labels.push(x.tipologia_danno_non_patrimoniale + " (" + x.percentuale + "%)");

      //@ts-ignore
      configTipologiaDannoNonPatrimoniale.data.datasets[0].data.push(x.percentuale);
    });

    let canvasTipologiaDannoNonPatrimoniale: HTMLElement | null = document.getElementById('canvas_tipologia_danno_non_patrimoniale');

    //@ts-ignore
    chartTipologiaDannoNonPatrimoniale = new Chart(canvasTipologiaDannoNonPatrimoniale, configTipologiaDannoNonPatrimoniale);

  }
}
function updateChartsDomandaAccolta(): void {
  if (Chart.getChart("canvas_domanda_accolta")) {
    Chart.getChart("canvas_domanda_accolta")?.destroy();
  }

  if (model.res_get_percorso.domanda_accolta && model.res_get_percorso.domanda_accolta.length > 0) {
    const configDomandaAccolta = {
      type: "doughnut",
      data: {
        labels: [],
        datasets: [{
          label: 'Domanda accolta',
          data: [],
          backgroundColor: Object.values(CHART_COLORS),
          hoverOffset: 4
        }],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'right',
            onClick: null
          }
        }
      }
    }

    model.res_get_percorso.domanda_accolta.forEach((x: KeyValoreStrNumBool) => {
      //@ts-ignore
      configDomandaAccolta.data.labels.push((x.domanda_accolta ? "Si" : "No") + " (" + x.percentuale + "%)");

      //@ts-ignore
      configDomandaAccolta.data.datasets[0].data.push(x.percentuale);
    });

    let canvasDomandaAccolta: HTMLElement | null = document.getElementById('canvas_domanda_accolta');

    //@ts-ignore
    chartDomandaAccolta = new Chart(canvasDomandaAccolta, configDomandaAccolta);
  }
}
function updateChartsRisarcimento(): void {
  if (Chart.getChart("canvas_risarcimento")) {
    Chart.getChart("canvas_risarcimento")?.destroy();
  }

  if (model.res_get_percorso.risarcimento && model.res_get_percorso.risarcimento.length > 0) {
    const configRisarcimento = {
      type: "doughnut",
      data: {
        labels: [],
        datasets: [{
          label: 'Esito risarcimento',
          data: [],
          backgroundColor: Object.values(CHART_COLORS),
          hoverOffset: 4
        }],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'right',
            onClick: null
          }
        }
      }
    }

    model.res_get_percorso.risarcimento.forEach((x: KeyValoreStrNumBool) => {
      //@ts-ignore
      configRisarcimento.data.labels.push(x.risarcimento + " (" + x.percentuale + "%)");

      //@ts-ignore
      configRisarcimento.data.datasets[0].data.push(x.percentuale);
    });

    let canvasRisarcimento: HTMLElement | null = document.getElementById('canvas_risarcimento');

    //@ts-ignore
    chartRisarcimento = new Chart(canvasRisarcimento, configRisarcimento);
  }
}

//QUERY
function callQueryPaginazione(): void {
  callQuery(true);
}
function callQuery(soloPaginazione: boolean = false): void {
  //chiama i dati attuali
  CommsResponsabilita.getInstance().queryPercorso((e: IEsito) => {
    updateComponents();
  }, soloPaginazione);
}

//FLOW
function changePercorsoAt(field: string): void {
  let valueField = "";
  let stringField = "";
  
  //pulire i successivi in model.res_flow_percorso
  if (field == "all") {
    model.res_flow_percorso.tipologia_danno = "";
    field = "tipologia_danno"
  }

  stringField = field;

  switch (field) {
    case "tipologia_danno":
      model.res_flow_percorso.tipologia_danno_patrimoniale = "";
      model.res_flow_percorso.tipologia_danno_non_patrimoniale = "";
      model.res_flow_percorso.domanda_accolta = "";
      model.res_flow_percorso.valori = false;

      valueField = model.res_flow_percorso.tipologia_danno;
      stringField = "tipologia danno";

      break;
    case "tipologia_danno_patrimoniale":
      model.res_flow_percorso.domanda_accolta = "";
      model.res_flow_percorso.valori = false;

      valueField = model.res_flow_percorso.tipologia_danno_patrimoniale;
      stringField = "danno patrimoniale";

      break;
    case "tipologia_danno_non_patrimoniale":
      model.res_flow_percorso.domanda_accolta = "";
      model.res_flow_percorso.valori = false;

      valueField = model.res_flow_percorso.tipologia_danno_non_patrimoniale;
      stringField = "danno non patrimoniale";

      break;
    case "domanda_accolta":
      model.res_flow_percorso.valori = false;

      valueField = model.res_flow_percorso.domanda_accolta;
      stringField = "domanda accolta";
      break;
    case "risarcimento":
      model.res_flow_percorso.valori = false;

      valueField = model.res_flow_percorso.risarcimento;
      stringField = "risarcimento";
      break;
    case "valori":
      valueField = model.res_flow_percorso.valori + "";

      if (valueField == "true") {
        valueField = "Si"
      } else {
        valueField = ""
      }
      stringField = "valori";
      break;
    case "risarcimento_richiesto":
      valueField = model.res_flow_percorso.risarcimento_richiesto_da + " - " + model.res_flow_percorso.risarcimento_richiesto_a;
      stringField = "risarcimento richiesto";
      break;
    case "risarcimento_disposto_totale":
      valueField = model.res_flow_percorso.risarcimento_disposto_totale_da + " - " + model.res_flow_percorso.risarcimento_disposto_totale_a;
      stringField = "risarcimento disposto totale";
      break;
  }

  if (valueField) {
    gtagO({
      event: 'filtro',
      filtro: stringField,
      valore: valueField,
      percorso: 'Responsabilita'
    })
  }

  callQuery();
}
function canShowCanvas(field: string): string {
  let stylo: string = "row blocco";
  switch (field) {
    case "tipologia_danno":
      break;
    case "tipologia_danno_patrimoniale":
      if (!model.res_get_percorso.tipologia_danno_patrimoniale || model.res_get_percorso.tipologia_danno_patrimoniale.length < 1 ||
          model.res_flow_percorso.tipologia_danno == "" || model.res_flow_percorso.tipologia_danno === "Non patrimoniale") stylo += " not-visible";
      break;
    case "tipologia_danno_non_patrimoniale":
      if (!model.res_get_percorso.tipologia_danno_non_patrimoniale || model.res_get_percorso.tipologia_danno_non_patrimoniale.length < 1 ||
          model.res_flow_percorso.tipologia_danno == "" || model.res_flow_percorso.tipologia_danno === "Patrimoniale") {
        stylo += " not-visible";
      }
      break;
    case "domanda_accolta":
      if (!model.res_get_percorso.domanda_accolta || model.res_get_percorso.domanda_accolta.length < 1 ||
          model.res_flow_percorso.tipologia_danno == "" || (model.res_flow_percorso.tipologia_danno_patrimoniale == "" && model.res_flow_percorso.tipologia_danno_non_patrimoniale == "")
      ) stylo += " not-visible";
      break;
    case "risarcimento":
      if (!model.res_get_percorso.risarcimento || model.res_get_percorso.risarcimento.length < 1 || model.res_flow_percorso.domanda_accolta != "Si") stylo += " not-visible";
      break;
  }
  return stylo
}
function canShowField(field: string): string {
  let canShow: string = "row blocco";
  switch (field) {
    case "tipologia_danno":
      break;
    case "tipologia_danno_patrimoniale":
      if (model.res_flow_percorso.tipologia_danno == "" || model.res_flow_percorso.tipologia_danno == "Non patrimoniale"
      ) canShow += " not-visible";
      break;
    case "tipologia_danno_non_patrimoniale":
      if (model.res_flow_percorso.tipologia_danno == "" || model.res_flow_percorso.tipologia_danno == "Patrimoniale"
      ) canShow += " not-visible";
      break;
    case "domanda_accolta":
      if (model.res_flow_percorso.tipologia_danno == "" || (model.res_flow_percorso.tipologia_danno_patrimoniale == "" &&
          model.res_flow_percorso.tipologia_danno_non_patrimoniale == "")
      ) canShow += " not-visible";
      break;
    case "risarcimento":
      if (model.res_flow_percorso.domanda_accolta != "Si") canShow += " not-visible";
      break;
    case "valori":
      if (model.res_flow_percorso.tipologia_danno == "" || (model.res_flow_percorso.tipologia_danno_patrimoniale == "" &&
          model.res_flow_percorso.tipologia_danno_non_patrimoniale == "")
      ) canShow += " not-visible";
      break;
    case "risarcimento_richiesto":
    case "risarcimento_disposto_totale":
      if (!model.res_flow_percorso.valori) {
        canShow += " not-visible";
      }
      break;
    case "finePercorso":
      if (model.res_flow_percorso.tipologia_danno == "" || (model.res_flow_percorso.tipologia_danno_patrimoniale == "" &&
          model.res_flow_percorso.tipologia_danno_non_patrimoniale == "")
      ) canShow += " not-visible";
      break;
  }
  return canShow;
}

//MINMAX
const fromMinMaxSlider = (active: boolean, cid: string) => {
  changePercorsoAt(cid)
};
const minMaxSlider_risarcimento_richiesto = ref(null);
const minMaxSlider_risarcimento_disposto_totale = ref(null);

const updateMinMaxSliders = (doSet: boolean = false): void => {
  try {
    if (doSet) {
      //@ts-ignore
      minMaxSlider_risarcimento_richiesto.value.updateMinMaxSlider(model.res_flow_dashboard.risarcimento_richiesto_da, model.res_flow_dashboard.risarcimento_richiesto_a)
      //@ts-ignore
      minMaxSlider_risarcimento_disposto_totale.value.updateMinMaxSlider(model.res_flow_dashboard.risarcimento_disposto_totale_da, model.res_flow_dashboard.risarcimento_disposto_totale_a);
    } else {
      //@ts-ignore
      minMaxSlider_risarcimento_richiesto.value.updateMinMaxSlider()
      //@ts-ignore
      minMaxSlider_risarcimento_disposto_totale.value.updateMinMaxSlider();
    }
  } catch (e) {
    //console.log("%%%%", e)
  }
}

//DASH
function vaiDashboard(): void {
  gtagO({
    event: 'link dashboard', 
    posizione: 'bottom Percorso',
    percorso: 'responsabilita'
  })
}

//DOCUMENTI
function apriDocumenti(): void {
  gtagO({
    event: 'elenco sentenze'
  })

  let docDiv: HTMLElement | null = document.getElementById("percorsoDocumenti");
  if (docDiv) docDiv.style.display = "block";
}
function sintetizzaConAi(estremi: string, id_doc_master: number, docRigaIndex: number): void {
  gtagO({
    event: 'sintetizza AI',
    target: estremi
  })

  let model: Model = Model.getReactiveInstance();
  CommsResponsabilita.getInstance().openSintesi('responsabilita-percorso', docRigaIndex, {
    id_doc_master: id_doc_master,
    username: model.user.profile.userId,
    crmid: model.user.profile.crmId
  });
}
function apriDettaglio(estremi: string = "", id_doc_master: number = -1, id_databanks: number = -1, id: string = ""): void {
  gtagO({
    event: 'apri dettaglio',
    target: estremi,
    destinazione: model.abbonatoDejure ? 'dejure' : 'overlay'
  })

  let comms: CommsResponsabilita = CommsResponsabilita.getInstance();
  if (id_doc_master < 0) {
    if (!model.openingDejure) {
      let allIds: number[] = [];
      model.res_get_percorso.sentenze_paginate.forEach((item: KeyValoreStrNum) => {
        if (item.estremi) {
          allIds.push(item.id_doc_master as number)
        }
      })
      if (model.abbonatoDejure) {
        model.openingDejure = true;
        comms.callDejure(allIds, ()=> { model.openingDejure = false});
      }
    }
  } else {
    if (model.abbonatoDejure) {
      comms.openDettaglioDejure(id_doc_master, id_databanks, id);
    } else {
      comms.openDettaglioModal(id_doc_master, id_databanks, id);
    }
  }
}

//PAGINAZIONE
const paginazione_component = ref(null);
const paginazione_jump_component = ref(null);

const updatePaginazione = (): void => {
  try {
    //@ts-ignore
    paginazione_component.value.updatePaginazione();
    //@ts-ignore
    if (paginazione_jump_component && paginazione_jump_component.value) paginazione_jump_component.value.updatePaginazione();
  } catch (e) {
    //console.log("%%%%", e)
  }
}

//REPORT
function generaReport(): void {
  let sFiltriAttivi = "";

  if (model.res_flow_percorso.tipologia_danno != "") {
    sFiltriAttivi = "Tipologia danno";
  }
  if (model.res_flow_percorso.tipologia_danno_patrimoniale) {
    if (sFiltriAttivi != "") { sFiltriAttivi += "|" }
    sFiltriAttivi += "Danno patrimoniale";
  }
  if (model.res_flow_percorso.domanda_accolta != "") {
    if (sFiltriAttivi != "") { sFiltriAttivi += "|" }
    sFiltriAttivi += "Domanda accolta";
  }
  if (model.res_flow_percorso.tipologia_danno_non_patrimoniale != "") {
    if (sFiltriAttivi != "") { sFiltriAttivi += "|" }
    sFiltriAttivi += "Danno non patrimoniale";
  }


  PdfGenerator.res_generatePdfPercorso("responsabilita");
  gtagO({
    event: 'genera report',
    filtriAttivi: sFiltriAttivi
  })
}

function isRebranding(): boolean {
  return frontendConfig.rebranding;
}
</script>

<template>
  <div class="container percorso percorso-page">

    <!-- TIPOLOGIA DANNO -->
    <div :class="canShowCanvas('tipologia_danno')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        <div class="row">
          <div class="col-4 p-2">
            &nbsp;<button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true" id="tooltip_tipologia_danno"
                          data-bs-title="Questo grafico ti permette di scegliere tra le sentenze relative ai procedimenti di risarcimento del danno patrimoniale, non patrimoniale o entrambe le ipotesi
Scegli il filtro di tuo interesse.">
            <i class="bi bi-info-circle-fill"></i>
          </button>
            <h6>Tipologia danno</h6><br>
            <em>Numero sentenze prese in esame</em><br>
            {{ model.res_get_percorso.totale_numero_sentenze.valore }}
          </div>
          <div class="col-8 canvasCont"><canvas id="canvas_tipologia_danno"></canvas></div>
        </div>
      </div>
    </div>
    <div :class="canShowField('tipologia_danno')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        Scegli il tipo da analizzare
      </div>
      <div class="col-1 pt-3">

      </div>
      <div class="col-11 p-3 px-0">
        <select class="form-select" id="input_tipologia_danno"
                v-model="model.res_flow_percorso.tipologia_danno"
                @change="changePercorsoAt('tipologia_danno')">
          <option value="">Scegli...</option>
          <option v-for="(item) in Model.lista_tipologia_danno" :value="item" :key="'tipologia_danno_' + item">
            {{item}}
          </option>
        </select>
      </div>
    </div>

    <!-- TIPOLOGIA DANNO PATRIMONIALE -->
    <div :class="canShowCanvas('tipologia_danno_patrimoniale')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        <div class="row">
            <div class="col-4 p-2">
              &nbsp;<button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true" id="tooltip_tipologia_danno_patrimoniale"
                      data-bs-title="Questo grafico ti permette di scegliere tra le diverse tipologie di danno patrimoniale. Scegli il filtro di tuo interesse.">
                <i class="bi bi-info-circle-fill"></i>
              </button>
              <h6>Danno patrimoniale</h6><br>
              <em>Numero sentenze prese in esame</em><br>
              {{ model.res_get_percorso.totale_numero_sentenze.valore }}
            </div>
            <div class="col-8 canvasCont"><canvas id="canvas_tipologia_danno_patrimoniale"></canvas></div>
        </div>
      </div>
    </div>
    <div :class="canShowField('tipologia_danno_patrimoniale')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        Specifica la tipologia di danno patrimoniale<br>
      </div>
      <div class="col-1 pt-3">&nbsp;</div>
      <div class="col-11 p-3 px-0">
        <select class="form-select" id="input_tipologia_danno_patrimoniale" v-model="model.res_flow_percorso.tipologia_danno_patrimoniale" @change="changePercorsoAt('tipologia_danno_patrimoniale')">
          <option value="">Scegli...</option>
          <option v-for="(item) in Model.lista_tipologia_danno_patrimoniale" :value="item" :key="'esito_'+item">{{item}}</option>
        </select>
      </div>
    </div>

    <!-- TIPOLOGIA DANNO NON PATRIMONIALE -->
    <div :class="canShowCanvas('tipologia_danno_non_patrimoniale')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        <div class="row">
          <div class="col-4 p-2">
            &nbsp;<button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true" id="tooltip_tipologia_danno_non_patrimoniale"
                          data-bs-title="Questo grafico ti permette di scegliere tra le diverse tipologie di danno non patrimoniale. Scegli il filtro di tuo interesse.">
            <i class="bi bi-info-circle-fill"></i>
          </button>
            <h6>Danno non patrimoniale</h6><br>
            <em>Numero sentenze prese in esame</em><br>
            {{ model.res_get_percorso.totale_numero_sentenze.valore }}
          </div>
          <div class="col-8 canvasCont"><canvas id="canvas_tipologia_danno_non_patrimoniale"></canvas></div>
        </div>
      </div>
    </div>
    <div :class="canShowField('tipologia_danno_non_patrimoniale')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        Specifica la tipologia di danno non patrimoniale<br>
      </div>
      <div class="col-1 pt-3">&nbsp;</div>
      <div class="col-11 p-3 px-0">
        <select class="form-select" id="input_tipologia_danno_non_patrimoniale" v-model="model.res_flow_percorso.tipologia_danno_non_patrimoniale" @change="changePercorsoAt('tipologia_danno_non_patrimoniale')">
          <option value="">Scegli...</option>
          <option v-for="(item) in Model.lista_tipologia_danno_non_patrimoniale" :value="item" :key="'esito_'+item">{{item}}</option>
        </select>
      </div>
    </div>

    <!-- domanda_accolta -->
    <div :class="canShowCanvas('domanda_accolta')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        <div class="row">
          <div class="col-4 p-2">
            &nbsp;<button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true" id="tooltip_domanda_accolta"
                    data-bs-title="Questo grafico ti permette di scegliere le sentenze in cui vi in cui vi è stato accoglimento della domanda di risarcimento oppure no. Scegli il filtro di tuo interesse.">
              <i class="bi bi-info-circle-fill"></i>
            </button>
            <h6>Domanda accolta</h6><br>
            <em>Numero sentenze prese in esame</em><br>
            {{ model.res_get_percorso.totale_numero_sentenze.valore }}
          </div>
          <div class="col-8 canvasCont"><canvas id="canvas_domanda_accolta"></canvas></div>
        </div>
      </div>
    </div>
    <div :class="canShowField('domanda_accolta')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        Scegli se analizzare i casi in cui la domanda è stata accolta
      </div>
      <div class="col-1 pt-3">
        &nbsp;
      </div>
      <div class="col-11 p-3 px-0">
        <select class="form-select" id="input_domanda_accolta" v-model="model.res_flow_percorso.domanda_accolta"
                @change="changePercorsoAt('domanda_accolta')">
          <option value="">Scegli...</option>
          <template v-if="model.res_get_percorso.domanda_accolta && model.res_get_percorso.domanda_accolta.length > 0">
            <option v-for="(item, index) in model.res_get_percorso.domanda_accolta" :value="(item.domanda_accolta ? 'Si' : 'No')" :key="'domanda_accolta_'+index"><span v-if="item.domanda_accolta.toString() === 'true'">Si</span><span v-else>No</span></option>
          </template>
          <template v-else>
            <option v-for="(item, index) in Model.lista_domanda_accolta" :value="item" :key="'esito_'+item">{{ item }}</option>
          </template>
        </select>
      </div>
    </div>

    <!-- risarcimento -->
    <div :class="canShowCanvas('risarcimento')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        <div class="row">
          <div class="col-4 p-2">
            &nbsp;
            <button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true" id="tooltip_risarcimento"
              data-bs-title="Questo grafico ti permette di selezionare l’esito della domanda risarcitoria. Scegli il tuo filtro di interesse.">
              <i class="bi bi-info-circle-fill"></i>
            </button>
            <h6>Esito risarcimento</h6><br>
            <em>Numero sentenze prese in esame</em><br>
            {{model.res_get_percorso.totale_numero_sentenze.valore}}
          </div>
          <div class="col-8 canvasCont"><canvas id="canvas_risarcimento"></canvas></div>
        </div>
      </div>
    </div>
    <div :class="canShowField('risarcimento')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        Scegli l'esito della domanda risarcitoria
      </div>
      <div class="col-1 pt-3">&nbsp;</div>
      <div class="col-11 p-3 px-0">
        <select class="form-select" id="input_risarcimento" v-model="model.res_flow_percorso.risarcimento" @change="changePercorsoAt('risarcimento')">
          <option value="">Scegli...</option>
          <template v-if="model.res_get_percorso.risarcimento && model.res_get_percorso.risarcimento.length > 0">
            <option v-for="(item, index) in model.res_get_percorso.risarcimento" :value="item.risarcimento" :key="'risarcimento_'+index">
              {{item.risarcimento}}
            </option>
          </template>
          <template v-else>
            <option v-for="(item) in Model.lista_risarcimento" :value="item" :key="'esito_'+item">{{ item }}</option>
          </template>
        </select>
      </div>
    </div>

    <!-- valori -->
    <div :class="canShowField('valori')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        Vuoi applicare i filtri di valore su risarcimento richiesto e risarcimento riconosciuto?
      </div>
      <div class="col-1 pt-3">

      </div>
      <div class="col-11 p-3 px-0">
        <label class="form-check-label" for="input_valori">Seleziona la casella in caso affermativo.</label>
        <input type="checkbox" class="form-check" id="input_valori"
               v-model="model.res_flow_percorso.valori"
               @change="changePercorsoAt('valori')" />

      </div>
    </div>

    <div :class="canShowField('risarcimento_richiesto')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        Individua il valore o un intervallo di valori dell’importo richiesto in risarcimento
        <span class="not-visible" v-if="model.res_get_percorso.risarcimento_richiesto.valore > 0" v-html="'&nbsp; (Mediano: ' + model.res_get_percorso.risarcimento_richiesto.valore + ')'"></span>
      </div>
      <div class="col-1 pt-3">
        &nbsp;
      </div>
      <div class="col-11 p-3 px-0">
        <div class="slider-cont percorso">
          <MinMaxSlider  ref="minMaxSlider_risarcimento_richiesto"
                         v-model:active="model.res_flow_percorso.risarcimento_richiesto_active"
                         v-model:min="model.res_flow_percorso.risarcimento_richiesto_min"
                         v-model:max="model.res_flow_percorso.risarcimento_richiesto_max"
                         :step="Model.lista_importi_minMax[2]"
                         v-model:min-value="model.res_flow_percorso.risarcimento_richiesto_da"
                         v-model:max-value="model.res_flow_percorso.risarcimento_richiesto_a"
                         :cid="'risarcimento_richiesto'"
                         :changeFunct="fromMinMaxSlider"
          />
          <div class="legenda"><span v-html="model.res_flow_percorso.risarcimento_richiesto_da"></span>
            &nbsp; <i class="bi bi-arrows"></i> &nbsp;
            <span v-html="model.res_flow_percorso.risarcimento_richiesto_a"></span></div>
        </div>


      </div>
    </div>
    <div :class="canShowField('risarcimento_disposto_totale')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        Individua il valore o un intervallo di valori dell’importo effettivamente riconosciuto
        <span class="not-visible" v-if="model.res_get_percorso.risarcimento_disposto_totale.valore > 0" v-html="'&nbsp; (Mediano: ' + model.res_get_percorso.risarcimento_disposto_totale.valore + ')'"></span>
      </div>
      <div class="col-1 pt-3">
        &nbsp;
      </div>
      <div class="col-11 p-3 px-0">
        <div class="slider-cont percorso">
          <MinMaxSlider  ref="minMaxSlider_risarcimento_disposto_totale"
                         v-model:active="model.res_flow_percorso.risarcimento_disposto_totale_active"
                         v-model:min="model.res_flow_percorso.risarcimento_disposto_totale_min"
                         v-model:max="model.res_flow_percorso.risarcimento_disposto_totale_max"
                         :step="Model.lista_importi_minMax[2]"
                         v-model:min-value="model.res_flow_percorso.risarcimento_disposto_totale_da"
                         v-model:max-value="model.res_flow_percorso.risarcimento_disposto_totale_a"
                         :cid="'risarcimento_disposto_totale'"
                         :changeFunct="fromMinMaxSlider"
          />
          <div class="legenda"><span v-html="model.res_flow_percorso.risarcimento_disposto_totale_da"></span>
            &nbsp; <i class="bi bi-arrows"></i> &nbsp;
            <span v-html="model.res_flow_percorso.risarcimento_disposto_totale_a"></span></div>
        </div>


      </div>
    </div>

    <!-- FINE PERCORSO -->
    <div :class="canShowField('finePercorso')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        Hai completato il percorso di analisi guidato sulle sentenze <span v-if="model.res_flow_percorso.tipologia_danno !=''">di <em>{{model.res_flow_percorso.tipologia_danno}}</em></span>
      </div>
      <div class="col-1 pt-3">
        &nbsp;
      </div>
      <div class="col-11 p-3 px-0 finepercorso">
        <div class="mb-2">Ora puoi scegliere tra due opzioni:<br>
          &bull; Genera l’elenco delle sentenze corrispondenti alle tue scelte.<br>
          &bull; Accedi alla dashboard per ulteriori analisi.<br>
          &nbsp; Qui potrai consultare i dati in base a vari criteri come:
          <span>Tribunale, Giudice, durata del processo</span>.<br>

          <button class="btn btn-lg btn-error my-3" @click="apriDocumenti()">
            <i class="bi bi-file-earmark"></i> &nbsp; Elenco Sentenze
          </button>
          <RouterLink to="/responsabilita/dashboard" class="btn btn-lg btn-error my-3" @click="vaiDashboard()">
            <i class="bi bi-graph-up"></i> &nbsp; Vai alla Dashboard
          </RouterLink>
        </div>

        <div id="percorsoDocumenti" class="pt-3" style="display: none">
          <h4>Elenco sentenze</h4>

          <div class="table-responsive small table-documenti"  v-if="model.res_get_percorso.sentenze_paginate && model.res_get_percorso.sentenze_paginate.length && model.res_get_percorso.sentenze_paginate.length > 0">
            <table class="table table-striped table-sm">
              <tbody>
              <template v-for="(item, index) in model.res_get_percorso.sentenze_paginate">
                <tr v-if="item.estremi" :id="'docRiga-responsabilita-percorso-'+index">
                  <!-- td><em>{{ (new Date(item.date)).toLocaleDateString() }}</em></td -->
                  <td>{{item.estremi}}</td>
                  <td class="text-right">
                    <a href="javascript:void(0)" @click="sintetizzaConAi(item.estremi as string, item.id_doc_master as number, index)" v-if="item.tipologia_doc != 136">
                      <i class="bi bi-stars"></i> Sintetizza con AI
                    </a>
                    <span v-else> </span>
                  </td>
                  <td class="text-right">
                    <a href="javascript:void(0)" @click="apriDettaglio(item.estremi as string, item.id_doc_master as number, item.id_databanks as number, item.id as string)">
                      <i class="bi bi-link"></i> Apri dettaglio
                    </a>
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>

          <div class="row"  v-if="model.res_get_percorso.sentenze_paginate && model.res_get_percorso.sentenze_paginate.length && model.res_get_percorso.sentenze_paginate.length > 0">

            <div class="col-12 col-sm-6 col-xl-4 paginazione-azione">
              <button class="btn btn-sm btn-primary" @click="apriDettaglio()" v-if="model.abbonatoDejure"><i class="bi bi-box-arrow-up-right" v-if="!model.openingDejure"></i> <div v-else class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>&nbsp;  Approfondisci su DeJure</button>

              <button class="btn btn-sm btn-error" @click="generaReport()" v-if="model.res_flow_percorso.tipologia_danno != ''">
                <i class="bi bi-download" v-if="!model.generatingPdf"></i> 
                <div v-else class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                &nbsp; Genera report
              </button>
            </div>

            <div class="col-12 col-sm-6 col-xl-3 paginazione-label">
              <b>{{ model.res_flow_percorso.paginazione_tot }}</b> Elementi Totali |
              Pagina <b>{{ (model.res_flow_percorso.paginazione_start + 1) }}</b> di
              <b>{{ (model.res_flow_percorso.paginazione_pages + 1) }}</b>
            </div>
            <div class="col-12 col-sm-12 col-xl-5">
              <PaginazionePercorso ref="paginazione_component" @recalc="callQueryPaginazione()"></PaginazionePercorso>
            </div>

            <!-- principi di diritto -->
            <div class="col-12 mt-4" v-if="model.abbonatoDejure && model.res_get_percorso.sentenze_paginate_jump_display && model.res_get_percorso.sentenze_paginate_jump_display.length && model.res_get_percorso.sentenze_paginate_jump_display.length > 0">
              <h4>Principi di diritto</h4>
              <div class="table-responsive small table-documenti">
                <table class="table table-striped table-sm">
                  <tbody>
                  <template v-for="(item, index) in model.res_get_percorso.sentenze_paginate_jump_display">
                    <tr v-if="item.estremi || item.id_doc_master" :id="'docRiga-responsabilita-percorso-jump-'+index">
                      <td v-if="item.estremi">{{item.estremi}}</td>
                      <td v-else> {{item.id_doc_master}}</td>
                      <td class="text-right">
                        <a href="javascript:void(0)" @click="apriDettaglio(item.estremi as string, item.id_doc_master as number, item.id_databanks as number, item.id as string)">
                          <i class="bi bi-link"></i> Apri dettaglio
                        </a>
                      </td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 col-xl-4 paginazione-azione">

                </div>
                <div class="col-12 col-sm-6 col-xl-3 paginazione-label">
                  <b>{{ model.res_flow_percorso.diritto_paginazione_tot }}</b> Elementi Totali |
                  Pagina <b>{{ (model.res_flow_percorso.diritto_paginazione_start + 1) }}</b> di
                  <b>{{ (model.res_flow_percorso.diritto_paginazione_pages + 1) }}</b>
                </div>
                <div class="col-12 col-sm-12 col-xl-5">
                  <PaginazionePercorsoJump ref="paginazione_jump_component"></PaginazionePercorsoJump>
                </div>
              </div>


            </div>

          </div>
          <div class="row" v-else>
            <div class="col-12">
              Non sono presenti sentenze
            </div>
          </div>

        </div>
      </div>

    </div>

  </div>

</template>